export default "__VITE_ASSET__BTDcNbPe__"